var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagmaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 40,
    viewBox: "0 0 151 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5907 39.9997C11.5907 39.9997 -7.93408 32.8595 4.25622 10.6665C4.25622 10.6665 3.10492 18.3758 5.11632 23.0298C7.12772 27.6838 9.89085 31.6604 11.5907 39.9997Z",
    fill: "url(#paint0_linear_137_23064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0791 40C17.3932 39.1384 19.5045 37.7964 21.278 36.0597C23.2429 34.1475 24.7331 31.7901 25.6264 29.1808C26.6625 25.7918 26.683 22.167 25.6853 18.7663C25.0408 16.1796 23.9325 13.7354 22.4158 11.5557C22.7529 15.1259 22.4133 18.7285 21.4154 22.1692C20.5261 25.1543 19.5321 26.5274 18.0282 30.2753C16.7689 33.424 15.7822 36.6778 15.0791 40Z",
    fill: "url(#paint1_linear_137_23064)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8464 32.8888C14.539 32.8888 14.9809 31.3913 16.2343 28.1222C17.039 26.0297 17.3622 25.4949 17.7119 24.4787C18.1192 23.3714 18.4498 22.2366 18.7013 21.0826C19.7119 16.6478 19.6871 12.0351 18.6288 7.61174C18.0624 5.72273 17.2101 3.93428 16.1023 2.31031C15.0799 0.812808 14.5654 0.0640568 13.82 0.00388924C11.841 -0.156557 9.73679 4.68358 8.85947 7.79892C7.75657 12.3738 7.85893 17.1621 9.15631 21.6842C9.60486 23.135 10.2645 24.8664 10.2645 24.8664C10.7526 26.1366 11.0363 26.5578 11.5838 28.1222C12.7514 31.1974 13.1208 32.8754 13.8464 32.8888Z",
    fill: "url(#paint2_linear_137_23064)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7783 33.0438V10.3656H44.4324L48.0179 20.4525C48.2477 21.125 48.4546 21.8091 48.6385 22.5047C48.8453 23.1772 49.0522 23.8844 49.259 24.6264H49.3969C49.6038 23.8844 49.7991 23.1772 49.983 22.5047C50.1669 21.8091 50.3737 21.125 50.6036 20.4525L54.1201 10.3656H59.7742V33.0438H55.1199V24.7308C55.1199 23.9888 55.1544 23.1192 55.2234 22.1221C55.3153 21.1018 55.4072 20.0931 55.4992 19.096C55.6141 18.0757 55.7175 17.1946 55.8095 16.4526H55.6716L53.8443 22.4351L50.6725 31.096H47.7076L44.5703 22.4351L42.812 16.4526H42.6741C42.766 17.1946 42.858 18.0757 42.9499 19.096C43.0648 20.0931 43.1568 21.1018 43.2257 22.1221C43.2947 23.1192 43.3292 23.9888 43.3292 24.7308V33.0438H38.7783Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1778 33.0438L69.2109 10.3656H75.2787L82.3463 33.0438H76.968L74.0376 21.5656C73.7158 20.4294 73.4055 19.2236 73.1067 17.9482C72.8079 16.6729 72.5091 15.4439 72.2103 14.2613H72.0724C71.8196 15.4439 71.5438 16.6729 71.245 17.9482C70.9462 19.2236 70.6359 20.4294 70.3142 21.5656L67.3492 33.0438H62.1778ZM66.7976 27.6525V23.6525H77.6231V27.6525H66.7976Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3948 33.4612C92.3493 33.4612 90.4876 33.0322 88.8097 32.1742C87.1549 31.2931 85.8333 29.9945 84.845 28.2786C83.8797 26.5395 83.397 24.3946 83.397 21.8438C83.397 19.9656 83.6843 18.296 84.2589 16.8352C84.8335 15.3511 85.6264 14.0989 86.6377 13.0787C87.649 12.0584 88.8097 11.2816 90.1198 10.7482C91.4529 10.2149 92.8664 9.94824 94.3604 9.94824C95.9922 9.94824 97.3942 10.2381 98.5664 10.8178C99.7386 11.3975 100.692 12.0932 101.428 12.9048L98.7733 16.0004C98.2217 15.4902 97.6126 15.096 96.9461 14.8178C96.3025 14.5163 95.4981 14.3656 94.5327 14.3656C93.3835 14.3656 92.3608 14.6671 91.4644 15.27C90.568 15.8497 89.867 16.6844 89.3613 17.7743C88.8557 18.8641 88.6029 20.1627 88.6029 21.6699C88.6029 23.2235 88.8327 24.5569 89.2924 25.6699C89.7751 26.7598 90.4761 27.5945 91.3954 28.1743C92.3378 28.754 93.51 29.0438 94.912 29.0438C95.3717 29.0438 95.8198 28.9858 96.2565 28.8699C96.6932 28.754 97.0495 28.58 97.3253 28.3482V24.4525H93.6019V20.2786H101.807V30.7134C101.049 31.4786 100.014 32.1279 98.7043 32.6612C97.4172 33.1945 95.9807 33.4612 94.3948 33.4612Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.451 33.0438V10.3656H112.105L115.69 20.4525C115.92 21.125 116.127 21.8091 116.311 22.5047C116.518 23.1772 116.725 23.8844 116.932 24.6264H117.07C117.276 23.8844 117.472 23.1772 117.656 22.5047C117.84 21.8091 118.046 21.125 118.276 20.4525L121.793 10.3656H127.447V33.0438H122.793V24.7308C122.793 23.9888 122.827 23.1192 122.896 22.1221C122.988 21.1018 123.08 20.0931 123.172 19.096C123.287 18.0757 123.39 17.1946 123.482 16.4526H123.344L121.517 22.4351L118.345 31.096H115.38L112.243 22.4351L110.485 16.4526H110.347C110.439 17.1946 110.531 18.0757 110.623 19.096C110.737 20.0931 110.829 21.1018 110.898 22.1221C110.967 23.1192 111.002 23.9888 111.002 24.7308V33.0438H106.451Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.85 33.0438L136.884 10.3656H142.951L150.019 33.0438H144.641L141.71 21.5656C141.388 20.4294 141.078 19.2236 140.779 17.9482C140.481 16.6729 140.182 15.4439 139.883 14.2613H139.745C139.492 15.4439 139.216 16.6729 138.918 17.9482C138.619 19.2236 138.309 20.4294 137.987 21.5656L135.022 33.0438H129.85ZM134.47 27.6525V23.6525H145.296V27.6525H134.47Z",
    fill: "#212121"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_23064",
    x1: 0.382414,
    y1: 16.8786,
    x2: 14.2988,
    y2: 38.4649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_137_23064",
    x1: 26.7577,
    y1: 16.4445,
    x2: 12.9561,
    y2: 37.9637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E9D776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_137_23064",
    x1: 13.754,
    y1: 4.10865,
    x2: 13.754,
    y2: 36.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BB1E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F95C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D776"
  })))));
}

export default __webpack_public_path__ + "media/52fd3924.svg";
export { SvgMagmaLogo as ReactComponent };